import { ApiClient } from '@/services/http/apiClient';
import type { ApiResponse, CategoryInput, CategoryResponse } from '@/types/api';

export const CategoryService = {
  admin: {
    async list(activeOnly = false): Promise<CategoryResponse[]> {
      const response = await ApiClient.get<ApiResponse<CategoryResponse[]>>('/admin/categories', {
        query: activeOnly ? { active_only: true } : undefined,
      });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao listar categorias');
      }
      return response.data;
    },

    async create(data: CategoryInput): Promise<CategoryResponse> {
      const response = await ApiClient.post<ApiResponse<CategoryResponse>>('/admin/categories', { body: data });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao criar categoria');
      }
      return response.data;
    },

    async update(id: number, data: Partial<CategoryInput>): Promise<CategoryResponse> {
      const response = await ApiClient.put<ApiResponse<CategoryResponse>>(`/admin/categories/${id}`, { body: data });
      if (!response.success) {
        throw new Error(response.message || 'Erro ao atualizar categoria');
      }
      return response.data;
    },

    async toggleActive(id: number): Promise<CategoryResponse> {
      const response = await ApiClient.patch<ApiResponse<CategoryResponse>>(`/admin/categories/${id}/toggle-active`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao alterar status da categoria');
      }
      return response.data;
    },

    async delete(id: number): Promise<void> {
      const response = await ApiClient.delete<ApiResponse<null>>(`/admin/categories/${id}`);
      if (!response.success) {
        throw new Error(response.message || 'Erro ao remover categoria');
      }
    },
  },
};
